import { z } from "zod";
import { playbookIdSchema } from "../entities/playbook.js";
import { teammateIdSchema } from "../entities/teammate.js";
import { topicIdSchema } from "../entities/topic.js";
const pageContextDescriptorSchema = z.discriminatedUnion("page", [
  z.object({
    page: z.literal("teammate"),
    playbookId: playbookIdSchema,
    teammateId: teammateIdSchema
  }),
  z.object({
    page: z.literal("playbook"),
    playbookId: playbookIdSchema
  }),
  z.object({
    page: z.literal("teammateAgent"),
    /** Voice agents are teammates of type AGENT. */
    teammateAgentId: teammateIdSchema
  }),
  z.object({
    page: z.literal("topics"),
    playbookId: playbookIdSchema,
    /** Set only when the user has drilled into one topic's page. */
    topicId: topicIdSchema.optional()
  })
]);
function resolvePageContextGrounding(pageContext, legacyThreadScope) {
  if (pageContext) {
    return pageContext;
  }
  const { teammateAgentId, playbookId } = legacyThreadScope;
  if (teammateAgentId) {
    return { page: "teammateAgent", teammateAgentId };
  }
  if (playbookId) {
    return { page: "playbook", playbookId };
  }
  return void 0;
}
export {
  pageContextDescriptorSchema,
  resolvePageContextGrounding
};
//# sourceMappingURL=pageContext.js.map
